import { MessageType } from '../types/messageTypes'

export const CHAT_ASSISTANT_ID = 'chatbot-id'
export const PRIVACY_POLICY_PAGE_PATHNAME = '/privacy-policy'

export const INDEXED_DB_NAME = 'chatbot'
export const INDEXED_DB_TABLE_NAME = 'conversation'

export const IS_CHAT_OPEN_KEY = 'isChatOpen'
export const IS_MESSAGE_PULLING_LS_ID = 'isChatbotPulling'
export const CHATBOT_SESSION_ID_LS_ID = 'chatbotSessionId'

export const ANALYTICS_LIST_ID = 'fashionAssistant'

export const CHAT_MESSAGE_CHOICES = [
	MessageType.InitIceBreakers,
	MessageType.QuickReplies,
	MessageType.OrderList,
	MessageType.LeaveAgentQueue,
	MessageType.SearchAddress,
]

export const ABORT_REASON = 'Chat dialog has been closed'
